<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent >
            <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListHandler($event)" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getListHandler($event)">搜索查询</el-button>
                <span>
                    <a class="export-tamplate" href="../../../doc/packagePriceMgt.xls" download="套餐价格批量导入模板.xls">下载模板</a>
                </span> 
            </el-form-item>

            <el-upload ref="uploadFile" class="uploadUrl" :action="uploadUrl('sim/import/price')" :headers="setHeader()" :on-success="handleSuccess" 
                :on-change="handleChange">
                <el-button slot="trigger" plain>批量导入</el-button>
            </el-upload>

        </el-form>

        

        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column type="index" label="序号" width="50" ></el-table-column>
            <el-table-column label="ICCID" >
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="packageName" label="套餐名称"  ></el-table-column>
            <el-table-column prop="price" label="价格（元）"  ></el-table-column>
            <el-table-column prop="importTime" label="导入时间"  ></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>        
    </div>
</template>

<script>
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                iccid: null,
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            supplierOption: [],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            }            
        }
    },
    methods: {

        getListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            let data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            common.sysRequest('sim/price/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
       
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListHandler(this.$event);
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListHandler(this.$event);
        },

        handleChange(file, fileList) {
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.$refs.uploadFile.clearFiles();
        },   

        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },    
    },
    created () {
        this.getListHandler(this.$event);
    }
}
</script>

<style lang="scss" scoped>

    .export-tamplate{
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        width: 85px;
        height: 32px;
        display: inline-block;
        text-align: center;
        vertical-align: baseline;
        margin-left: 10px;
        font-size: 13px;
        color: #606266;
    }

    .export-tamplate:hover{
        color: #409EFF;
        border-color: #409EFF;
        transition: .3s;
    }

    .uploadUrl{
        box-sizing: border-box;
        border-radius: 3px;
        width: 180px;
        height: 64px;
        display: inline-block;
        vertical-align: baseline;
        margin-left: 10px;
        font-size: 13px;
        color: #606266;
    }


</style>

